import { useDragContext } from '../context';
import { DragSource } from '../index';
import { Item } from '../source/item';
import { setGrid } from 'store/reducers/quotes';
import { useDispatch } from 'react-redux';

const panel_item_default_style = {
  height: '75px',
  width: '100%',
  background: '#7CBE7B',
  border: '6px solid #FFFFFF',
  boxSizing: 'border-box',
  borderRadius: '5px',
  fontSize: '48px',
  lineHeight: 'initial',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#ffffff'
}

const panel_styles = {
  1: {
    panel_style: {
      width: '100%',
      height: '155px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between'
    },
    panel_item_style: {
      1: {
        background: 'red'
      },
      2: {},
      3: {}
    },
  },
  2: {
    panel_item_style: {

    }
  },
  3: {
    panel_item_style: {

    }
  }
}

const styles = {
  a: {
    1: {
      flex: 1,
      marginRight: '3px',
      height: '100%',
    },
    2: {
      flex: 1,
      height: '100%'
    }
  },
  b: {
    1: {
      height: '50%',
      marginBottom: '3px',
      width: '100%',
    },
    2: {
      height: '50%',
      width: '100%'
    }
  },
  c: {
    1: {
      width: '100%',
      height: '100%'
    }
  },
  d: {
    1: {
      flex: 1,
      minWidth: '49%',
      height: '50%',
      marginBottom: '3px',
      marginRight: '3px'
    },
    2: {
      flex: 1,
      minWidth: '49%',
      height: '50%',
      //marginBottom: '3px'
    },
    3: {
      flex: 1,
      minWidth: '49%',
      height: '50%',
      marginRight: '3px'
    },
    4: {
      flex: 1,
      minWidth: '49%',
      height: '50%'
    },
  },
  e: {
    1: {
      flex: 1,
      marginRight: '3px',
      height: '100%'
    },
    2: {
      flex: 1,
      marginRight: '3px',
      height: '100%'
    },
    3: {
      flex: 1,
      marginRight: '3px',
      height: '100%'
    },
    4: {
      flex: 1,
      height: '100%'
    }
  },
  x: {
    1: {
      height: '50%',
      flex: 1,
      marginRight: '3px',
      marginBottom: '3px'
    },
    2: {
      height: '50%',
      flex: 1
    },
    3: {
      width: '100%',
      height: '50%'

    }
  },
  y: {
    1: {
      width: '100%',
    },
    2: {
      width: '49%',
    },
    3: {
      width: '49%'
    }
  },
  z: {
    1: {
      flex: 1,
      marginRight: '3px',
      height: '100%'
    },
    2: {
      flex: 1,
      marginRight: '3px',
      height: '100%'
    },
    3: {
      flex: 1,
      height: '100%'
    }
  }
}

export const Panel = ({
  type,
  onDragEnd,
  quantity
}) => {
  const _dispatch = useDispatch();
  const { state: { items } } = useDragContext();
  let _items = items
      .filter(item=>item.value <= quantity)
      // .slice(0, quantity);

  // while (_items.some(item => item.value > quantity)) {
  //     // const val = parseInt(item.value) === 1 ? item.value : parseInt(item.value) - 1
  //   _items = _items
  //
  //       .map(item => ({
  //     ...item,
  //     value: parseInt(item.value) === 1 ? item.value : parseInt(item.value) - 1
  //   }));
  // }

  function onClickCallback() {
    // console.log('onCLickCallback')
    _dispatch(setGrid('1-0'));
    onDragEnd();
  }

  return (
    <>
      {
        type === 'c' ?
        <div
        onClick = { onClickCallback }
        style = {{
          ...panel_styles[1].panel_style,
        }}
        >
          <div
          style = {{
            ...panel_item_default_style,
            ...styles['c'][1]
          }}
          >
            1
          </div>
        </div>
        :
        <DragSource
        items = { _items }
        onDragEnd = { onDragEnd }
        >
          <div
          style = { panel_styles[1].panel_style }
          >
            {
              _items.map((x, i) => (
                <Item
                quantity = { quantity }
                id = { x.id }
                value = { x.value }
                key = { `btn_${x.id}_${x.value}` }
                style = {{
                  ...panel_item_default_style,
                  ...styles[type][(i + 1)]
                }}
                />
              ))
            }
            </div>
        </DragSource>
      }
    </>
  )
}
